import { useAppState, useAppDispatch } from './Context'
import LocationCard from './LocationCard'

function LocationList({ noResultsContent, hideByDefault }) {
  const dispatch = useAppDispatch()
  const { selectedFilters, visibleLocations } = useAppState()

  const handleClick = (location) => {
    dispatch({ type: 'setSelectedLocation', payload: location })
  }

  return (
    <div className="overflow-scroll flex-1 overflow-scroll-touch">
      <div className="px-6 pt-6 md:pt-0 lg:px-8 xl:p-8 xl:pt-12">
        {selectedFilters.length > 0 && <h2 className="text-lg font-semibold xl:mt-3 xl:text-2xl">Filtered Results</h2>}
      </div>

      <div className="relative divide-y divide-gray xl:top-[0.5px]">
        {visibleLocations.length ? (
          visibleLocations.map((location) => (
            <LocationCard
              key={location.id}
              location={location}
              hideByDefault={hideByDefault}
              onClick={() => handleClick(location)}
            />
          ))
        ) : (
          <div className="px-6 lg:px-8">
            <div className="richtext wysiwyg" dangerouslySetInnerHTML={{ __html: noResultsContent }} />
          </div>
        )}
      </div>
    </div>
  )
}

export default LocationList
